import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { JackpotIntroBanner } from "./JackpotIntroBanner";
import { getJackpotEntryByIndex } from "../../core/utils";

export class JackpotIntroBannerComponent extends AbstractDisplayComponent {
    private container: Container;
    private upgradeValue: number = 0;
    private respinsCount: number = 3;

    public override init() {
        let containerConfig = {
            labelName: "jp_intro_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 0,
                posY: 0,
                scale: 1,
            },
            portrait: {
                posX: 0,
                posY: 0,
                scale: 1,
            }
        };

        this.container = new JackpotIntroBanner(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

    public play(callback: () => void) {
        const scarabCount = getJackpotEntryByIndex(this.upgradeValue)?.key || 0;
        (this.container as JackpotIntroBanner).playBannerAnimSequence(this.respinsCount, scarabCount, callback);
        this.upgradeValue++;
    }
}
